<template>
  <div>
    <table class="pse-table">
      <thead>
        <tr><th style="width: 200px;">Category</th><th>Files</th><th style="width: 130px;"></th></tr>
      </thead>
      <tbody>
        <tr v-for="c in categories" :key="c">
          <td>{{ c }}</td>
          <td>
            <div v-for="a in filesOf(c)" :key="a.key">
              <i class="pi pi-file"></i>
              <span v-if="a.queued"> {{ a.name }} <span class="pse-muted">(uploads when the enquiry is saved)</span>
                <span class="pse-link" @click="unqueue(a)"> remove</span></span>
              <span v-else class="pse-link" @click="download(a)"> {{ a.name }}</span>
            </div>
            <span v-if="!filesOf(c).length" class="pse-muted">none</span>
          </td>
          <td>
            <input :ref="'file_' + c" type="file" multiple style="display: none;" @change="picked(c, $event)" />
            <Button label="Add files" icon="pi pi-paperclip" class="p-button-sm p-button-outlined" :disabled="busy" @click="choose(c)" />
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="error" class="pse-note error"><i class="pi pi-times-circle"></i><span>{{ error }}</span></div>
  </div>
</template>

<script>
import api from './sharedEnquiryApi'
import { ATTACH_CATEGORIES, errorText } from './sharedEnquiryLogic'
import AttachmentService from '@/service/AttachmentService'

const nameOf = a => a.fileName || a.attachName || a.fileOriginalName || a.name || ('attachment ' + (a.attachmentId || a.id))

export default {
  name: 'AttachmentsByCategory',
  props: {
    // null while the enquiry is being entered: files are held here and uploaded by uploadQueued()
    sharedEnqId: { type: Number, default: null }
  },
  data() {
    return { categories: ATTACH_CATEGORIES, saved: [], queued: [], busy: false, error: '', seq: 0 }
  },
  watch: {
    sharedEnqId: { immediate: true, handler() { this.load() } }
  },
  methods: {
    async load() {
      if (!this.sharedEnqId) { this.saved = []; return }
      try {
        const rows = await api.attachments(this.sharedEnqId)
        this.saved = (rows || []).map(a => ({ ...a, key: 's' + (a.attachmentId || a.id), name: nameOf(a), category: a.category || a.attachCategory || 'Other' }))
      } catch (e) {
        this.error = errorText(e, 'Could not load the attachments')
      }
    },
    filesOf(c) {
      return this.saved.filter(a => a.category === c).concat(this.queued.filter(a => a.category === c))
    },
    choose(c) {
      const el = this.$refs['file_' + c]
      ;(Array.isArray(el) ? el[0] : el).click()
    },
    async picked(c, ev) {
      const files = Array.from(ev.target.files || [])
      ev.target.value = ''
      if (!files.length) return
      if (!this.sharedEnqId) {
        files.forEach(f => this.queued.push({ key: 'q' + (this.seq++), name: f.name, file: f, category: c, queued: true }))
        this.$emit('queued', this.queued.length)
        return
      }
      await this.upload(this.sharedEnqId, files.map(f => ({ file: f, category: c })))
      await this.load()
    },
    unqueue(a) {
      this.queued = this.queued.filter(q => q !== a)
      this.$emit('queued', this.queued.length)
    },
    async upload(id, items) {
      this.busy = true
      this.error = ''
      const failed = []
      // all at once: each upload can take seconds
      await Promise.all(items.map(it => api.uploadAttachment(id, it.file, it.category)
        .catch(e => { failed.push(it.file.name + ' (' + errorText(e) + ')') })))
      this.busy = false
      if (failed.length) this.error = 'Not uploaded: ' + failed.join('; ')
      return failed.length === 0
    },
    /** Called by the new-enquiry form once the shared enquiry exists. */
    async uploadQueued(id) {
      if (!this.queued.length) return true
      const ok = await this.upload(id, this.queued)
      this.queued = []
      return ok
    },
    download(a) {
      new AttachmentService().fileDownloader(a.name)
    }
  }
}
</script>

<style scoped>
@import './sharedEnquiry.css';
</style>
